var React = require('react');

function Dot (props) {
    return React.createElement("svg",props,React.createElement("circle",{"id":"Ellipse_699","data-name":"Ellipse 699","cx":"8","cy":"8","r":"8","fill":"#232a52"}));
}

Dot.defaultProps = {"width":"28","height":"28","viewBox":"0 0 16 16"};

module.exports = Dot;

Dot.default = Dot;
